module.exports = __webpack_public_path__ + "img/introduction02_top_01.a8b619e4.png";